export default function defer() {
    // http://bluebirdjs.com/docs/api/deferred-migration.html
    let resolve
    let reject

    /* eslint-disable-next-line promise/param-names */
    const promise = new Promise((arg1, arg2) => {
        resolve = arg1
        reject = arg2
    })

    return {
        resolve,
        reject,
        promise,
    }
}
